import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, Star } from 'lucide-react';
export function AudienceSection() {
  const isFor = ['Padres latinos en EE.UU. que quieren criar hijos independientes y líderes.', 'Niños de 8 a 15 años que tienen mucha energía pero no saben cómo canalizarla.', 'Familias que quieren una actividad productiva para hacer juntos el fin de semana.', 'Padres que quieren que sus hijos dominen el inglés y la comunicación social hablando con vecinos reales.'];
  const isNotFor = ["Padres que buscan una 'fórmula mágica' para hacerse ricos sin mover un dedo.", 'Personas que no están dispuestas a supervisar a su hijo durante las primeras 2 horas de práctica.', 'Niños que no tienen interés en ganar su propio dinero para sus gustos.'];
  return <section className="py-20 md:py-32 bg-gray-light px-4" data-id="element-8">
      <div className="max-w-5xl mx-auto" data-id="element-9">
        <div className="grid md:grid-cols-2 gap-8 mb-24" data-id="element-10">
          {/* Who this is for */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl p-8 shadow-lg border-t-4 border-green-500" data-id="element-11">
            <h3 className="text-2xl font-heading font-bold text-navy mb-6 flex items-center gap-3" data-id="element-12">
              <span className="bg-green-100 text-green-600 p-2 rounded-full" data-id="element-13">
                <Check className="w-6 h-6" data-id="element-14" />
              </span>
              Esto SÍ es para:
            </h3>
            <ul className="space-y-4" data-id="element-15">
              {isFor.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-16">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-17" />
                  <span className="font-body text-gray-700" data-id="element-18">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who this is not for */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl p-8 shadow-lg border-t-4 border-red-500" data-id="element-19">
            <h3 className="text-2xl font-heading font-bold text-navy mb-6 flex items-center gap-3" data-id="element-20">
              <span className="bg-red-100 text-red-600 p-2 rounded-full" data-id="element-21">
                <X className="w-6 h-6" data-id="element-22" />
              </span>
              Esto NO es para:
            </h3>
            <ul className="space-y-4" data-id="element-23">
              {isNotFor.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-24">
                  <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-25" />
                  <span className="font-body text-gray-700" data-id="element-26">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        {/* Proof / Believability */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-orange text-white rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-27">
          {/* Decorative stars */}
          <div className="absolute top-4 left-4 opacity-20" data-id="element-28">
            <Star className="w-12 h-12" fill="currentColor" data-id="element-29" />
          </div>
          <div className="absolute bottom-4 right-4 opacity-20" data-id="element-30">
            <Star className="w-16 h-16" fill="currentColor" data-id="element-31" />
          </div>

          <div className="relative z-10 max-w-3xl mx-auto" data-id="element-32">
            <h3 className="text-2xl md:text-3xl font-heading font-bold mb-6" data-id="element-33">
              La confianza no se compra, se gana.
            </h3>
            <p className="text-lg md:text-xl font-body font-medium leading-relaxed" data-id="element-34">
              "Un niño que aprende a ganar $20 por su cuenta a los 10 años,
              desarrolla una confianza que no se compra con ningún curso. En
              solo 7 días, verás a tu hijo caminar con la espalda más derecha,
              hablar con más claridad y, por primera vez, cuidar cada dólar
              porque sabe exactamente cuánto sudor le costó conseguirlo."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}